// Ana sayfa görünüm ayarları (Ayarlar → Görünüm). Giriş yapılmışsa /api/appearance (ana sayfa görseli
// token'lı istekle, blob olarak); giriş yoksa /api/public/appearance (yalnız herkese açık alanlar +
// giriş ekranı görseli). Sekmeye dönüldüğünde (en fazla dakikada bir) yeniden okunur → deploy gerekmez.
// Hata olursa varsayılanlar (bugünkü davranış) geçerli kalır.
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API, BACKEND_URL } from "../lib/api";
import { HOME_DEFAULTS, normalizeHomeAppearance } from "../lib/appearanceSettings";

const REFRESH_MIN_MS = 60 * 1000;

export default function useHomeAppearance(loggedIn, enabled = true) {
  const [appearance, setAppearance] = useState(HOME_DEFAULTS);
  const [ready, setReady] = useState(false);
  const [bgSrc, setBgSrc] = useState(null);
  const lastFetch = useRef(0);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    setReady(false);
    lastFetch.current = Date.now();
    axios.get(loggedIn ? `${API}/appearance` : `${API}/public/appearance`)
      .then((r) => { if (alive) setAppearance(normalizeHomeAppearance(r.data)); })
      .catch(() => { if (alive) setAppearance(HOME_DEFAULTS); })
      .finally(() => { if (alive) setReady(true); });
    return () => { alive = false; };
  }, [loggedIn, enabled, tick]);

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible" && Date.now() - lastFetch.current > REFRESH_MIN_MS) setTick((t) => t + 1);
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => { document.removeEventListener("visibilitychange", onVisible); window.removeEventListener("focus", onVisible); };
  }, []);

  // Görsel: giriş sonrası token'lı blob; giriş öncesi herkese açık adres. İç görsel giriş öncesine düşmez.
  const url = loggedIn ? appearance.background_url : appearance.login_background_url;
  useEffect(() => {
    if (!url) { setBgSrc(null); return undefined; }
    const full = `${BACKEND_URL}${url}`;
    if (!loggedIn) { setBgSrc(full); return undefined; }
    let alive = true;
    let objectUrl = null;
    axios.get(full, { responseType: "blob" })
      .then((r) => { if (alive) { objectUrl = URL.createObjectURL(r.data); setBgSrc(objectUrl); } })
      .catch(() => { if (alive) setBgSrc(null); });
    return () => { alive = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url, loggedIn]);

  return { appearance, ready, bgSrc };
}
